export enum MutiSelectMode {
  LIST = "list",
  RANGE = "range"
}
